import { type ExportNotification, isExportNotification, type Notification } from '@ikegps/core-api';
import type { CollectionModel } from '@ikegps/core-shared';

export class ExportNotificationCtrl {
	errors: boolean;
	notifications: ExportNotification[];

	private collections: { [revision: string]: CollectionModel } = {};

	constructor(notifications: Notification[]) {
		const exportNotifications = (notifications || []).filter(isExportNotification);
		const notificationsWithErrors = this.getNotificationsWithErrors(exportNotifications);
		this.errors = notificationsWithErrors.length > 0;

		if (this.errors) {
			this.notifications = notificationsWithErrors;
		} else {
			this.notifications = this.getNotificationsWithWarnings(exportNotifications);
		}
	}

	private getNotificationsWithErrors(notifications: ExportNotification[]): ExportNotification[] {
		return notifications.filter((notification) => notification.errors.length > 0);
	}

	private getNotificationsWithWarnings(notifications: ExportNotification[]): ExportNotification[] {
		return notifications.filter((notification) => notification.warnings.length > 0);
	}

	getRevisions(): string[] {
		return this.notifications.map((notification) => notification.revision);
	}

	setCollections(collections: CollectionModel[]) {
		this.collections = collections.reduce(
			(map: { [key: string]: CollectionModel }, collection) => {
				map[collection.revision] = collection;
				return map;
			},
			{} as { [key: string]: CollectionModel }
		);
	}

	getCollection(revision: string): CollectionModel {
		return this.collections[revision];
	}

	getTitleFieldName(revision: string): string {
		return this.getCollection(revision).schema.titleField.displayName;
	}
}
